export const authPath = {
  SIGNUP_PATH: "auth/sign_up",
  LOGIN_PATH: "auth/sign_in",
  VERIFY_EMAIL_PATH: "auth/verify_email",
  SET_USER_PASSWORD: "auth/set_user_password",
  LOGOUT_PATH: "auth/logout",
  FORGOT_PASSWORD_PATH: "auth/forgot_password",
  RESET_PASSWORD_PATH: "auth/reset_password/",
  USER_VERIFY: "/auth/verify_user",
  REFRESH_TOKEN: "auth/refresh_token",
};

export const userDocument = {
  UPDATE_DOCUMENT: "v2/documents/",
  UPLOAD_DOCUMENT: "v2/documents",
  DOCUMENT_LISTING: "documents",
  DELETE_DOCUMENT: "v2/documents/destroy",
  GET_DOCUMENT: "documents/",
  ARCHIVE_DOCUMENT: "v2/documents/:uuid/archive/",
  FAVOURITE_DOCUMENT: "documents/",
  SYNC_DOCUMENT: "v2/documents/:uuid/sync/",
  UNSYNC_DOCUMENT: "v2/documents/:uuid/unsync/",
  RESYNC_DOCUMENT: "v2/documents/resync",
  DOCUMENT_LABEL: "label/create_label",
  LABEL_LISTING: "label/list_label",
  SINGLE_LABEL: "label/get_label/",
  UPDATE_LABEL: "label/update_label/",
  DELETE_LABEL: "label/delete_label/",
  APPLY_LABEL: "documents/add_label",
  REMOVE_TAGS: "documents/remove_label/",
  CRAWLLED_DOCUMENT_LINK: "documents/site_map",
  CRAWL_DOCUMENT: "v2/documents/crawl",
};

export const userManagement = {
  GET_USER_ROLES: "role/list_role",
  GET_USER_LIST: "user/list_user",
  GET_PARTICULAR_USER: "user/get_user/",
  ADD_USER: "user/add_user",
  EDIT_USER: "user/update_user/",
  ACTIVATE_DEACTIVATE_USER: "user/activate_user/",
  DELETE_USER: "user/delete_user/",
};

export const projectManagement = {
  GET_PROJECT_LIST: "/project/list_project",
  GET_PARTICULAR_PROJECT: "/project/get_project/",
  ADD_PROJECT: "/project/create_project",
  EDIT_PROJECT: "/project/update_project/",
  DELETE_PROJECT: "/project/delete_project/",
  SWITCH_PROJECT_LIST: "/project/list_switch_project",
};

export const projectPersmission = {
  GET_PROJECT_PERMISSION: "/project/get_project_permission/",
  GENERATE_JWT: "/project/create_project_token",
};

export const profileManagement = {
  MANAGE_PROFILE: "/auth/update_profile",
  CHANGE_PASSWORD: "/auth/change_password",
  GET_PROFILE: "/auth/get_profile/",
};

//chatbot paths starts

export const path = {
  GET_SITE_DATA: "/setting/project_details",
  GET_CONVERSATIONS_DATA: "/user/conversation/list_conversation",
  GET_PARTICULAR_CONVERSATION_DATA: "/user/conversation/get_conversation",
  GET_INVITE_ONLY_USERS_DOCUMENT_LABELS:
    "/share/invitation/get_invitation_access/",
  UPDATE_PARTICULAR_CONVERSATION_DATA: "/user/conversation/update_conversation",
  CLEAR_ALL_CONVERSATIONS_DATA: "/user/conversation/clear_conversation",
  CLEAR_PARTICULAR_CONVERSATION_DATA: "/user/conversation/delete_conversation",
  SEND_QUESTION_DATA: "v2/process-prompt",
  SEND_USER_REACTION: "is_liked",
  RESET_SITE_DATA: "/projects/",
  LABEL_DATA: "/label/list_chatbot_label",
};

export const shareDocument = {
  SHARE_DOCUMENT_SETTINGS: "/setting/project_setting/",
  SEND_SHARE_ACCESS_TOGGLE_VALUE: "/share_project/",
  INVITE_ONLY: "/share/invitation/send_invitation",
};

//chatbot paths ends

export const roleManagement = {
  ROLE_LISTING: "/role/list_role",
  DELETE_ROLE: "/role/delete_role/",
  MODULE_LIST: "/module/list_module",
  CREATE_ROLE: "/role/create_role",
  GET_SINGLE_ROLE: "/role/get_role_permission/",
  UPDATE_ROLE: "/role/update_role/",
  ACTIVE_ROLE: "/role/activate_role/",
};

export const summaryPrompt = {
  GET_SUMMARY_PROMPT: "/summary-prompt",
  CREATE_SUMMARY_PROMPT: "/summary-prompt/store",
  SHOW_SUMMARY_PROMPT: "/summary-prompt/:uuid/show",
  UPDATE_SUMMARY_PROMPT: "/summary-prompt/:uuid/update",
  DELETE_SUMMARY_PROMPT: "/summary-prompt/:uuid/destroy",
  BULK_DELETE_SUMMARY_PROMPT: "/summary-prompt/destroy-all",
  ACTIVATE_SUMMARY_PROMPT: "/summary-prompt/:uuid/activate",
  GET_VIEW_SUMMARY_TEXT: "/documents/summary-text/",
  UPDATE_SUMMARY_TEXT: "/documents/summary-text/update/",
  GET_REGENERATED_SUMMARY_PROMPT: "/documents/summary-text/regenerate/",
};

export const personas = {
  GET_BASE_PROMPT: "/persona",
  SHOW_BASE_PROMPT: "/persona/:uuid/show",
  CREATE_BASE_PROMPT: "/persona/store",
  UPDATE_BASE_PROMPT: "/persona/:uuid/update",
  DELETE_BASE_PROMPT: "/persona/:uuid/destroy",
  BULK_DELETE_BASE_PROMPT: "/persona/destroy-all",
  ACTIVATE_BASE_PROMPT: "/persona/:uuid/activate",
};

export const tones = {
  GET_TONE: "/prompt-tone",
  SHOW_TONE: "/prompt-tone/:uuid/show",
  CREATE_TONE: "/prompt-tone/store",
  UPDATE_TONE: "/prompt-tone/:uuid/update",
  DELETE_TONE: "/prompt-tone/:uuid/destroy",
  BULK_DELETE_TONE: "/prompt-tone/destroy-all",
};
